export const environment = {
  production: true,
  baseUrl: 'https://referentiel-api-dev.restosducoeur.org/referentiels/api/1.0/',
  hostname: 'referentiel-api-dev.restosducoeur.org',
  timeoutResponseAPI: 60000,
  // utiliser si vous voulez changer l'url de backend explicitement
};
